
import { request, METHOD } from '@/utils/request.js'

// 查询教师信息
export function getTeacherInfoByOpenId(data) {
    return request(
      'h5Mfitness/teacher/getTeacherInfoByOpenId',
      METHOD.POST,
      data
    )
  }


  export function getOneSchoolByTeacherOpenId(data) {
    return request(
      'h5Mfitness/teacher/getOneSchoolByTeacherOpenId',
      METHOD.POST,
      data
    )
  }
